export default {
  init() {

    var docHeight    = $(document).height();
    var windowHeight = $(window).height();
    var scrollPercent;

    var setScrollbarWidth = function() {
      scrollPercent = $(window).scrollTop() / (docHeight - windowHeight) * 100;
      $(".scroll-progressbar .active").width(scrollPercent + '%');
    }

    $(function () {

      // Progressbar
      var progressbar = $(".scroll-progressbar");
      if (progressbar.length > 0) {
        setScrollbarWidth();
        $(window).scroll(function () { setScrollbarWidth(); });
      
        $(window).scroll(function() {
          try {
            var scrollTop    = $(window).scrollTop();
            var headerHeight = $("header.banner").height() - 4;
            var adminBarHeight = $('#wpadminbar') ? $('#wpadminbar').height() : 0;

            if(scrollTop >= 303) progressbar.addClass("sticky").css({"top" : headerHeight + adminBarHeight + "px"});
            else                 progressbar.removeClass("sticky").css({"top" : 0});
          }
          catch(err) {
            console.error(err);
          }
        });
  
        // Open Menu
        $(document).on("click", ".scroll-progressbar .menu:not(.opened)", function(e) {
          e.preventDefault();
          $(".scroll-progressbar .menu").addClass("opened");
        });
  
        // Close Menu
        $(document).on("click", ".scroll-progressbar .menu-close", function(e) {
          e.preventDefault();
          $(".scroll-progressbar .menu").removeClass("opened");
        });
      }

    });
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/scroll-progressbar.js